import script from "./RightPanelTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./RightPanelTitle.vue?vue&type=script&setup=true&lang=js"

import "./RightPanelTitle.vue?vue&type=style&index=0&id=421f2d23&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-421f2d23"]])

export default __exports__